import { createReducer, on } from '@ngrx/store';
import { sessionEnded } from './errors.actions';
import { ErrorsState, initialState } from './errors.state';

export const errorsReducer = createReducer(
  initialState,
  on(sessionEnded, (state): ErrorsState => ({ ...state, hasSessionEnded: true })),
);
